import type { PropType } from 'vue'
import { defineComponent } from 'vue'
import type { NavRoute } from '@/augmentations'

export default defineComponent({
  name: 'ApiViewsNav',
  props: {
    prevRoute: {
      type: Object as PropType<NavRoute>,
    },
    nextRoute: {
      type: Object as PropType<NavRoute>,
    },
  },
  setup() {
    return {}
  },
})
